export const vendorConfigs = [
  {
    tenantId: -1,
    id: "pehp",
    displayName: "PEHP",
    type: "employer",
  },
  {
    tenantId: 1152,
    id: "brose",
    displayName: "Brose",
    type: "employer",
  },
  {
    tenantId: 4362,
    id: "carboncollective",
    displayName: "Carbon Collective",
    type: "employer",
  },
  {
    tenantId: 1669,
    id: "thatch",
    displayName: "Thatch Health, Inc.",
    type: "employer",
  },
  {
    tenantId: -1, // Checked with Sabrina, partner do not go through employer dashboard, so we dont need to check their tenantId
    id: "oneeleven",
    displayName: "OneEleven",
    type: "partner",
  },
  {
    tenantId: -1,
    id: "perks",
    displayName: "Perks",
    type: "partner",
  },
  {
    tenantId: -1,
    id: "sunnydayfund",
    displayName: "Sunny Day Fund",
    type: "partner",
  },
  {
    tenantId: -1,
    id: "senda",
    displayName: "Senda",
    type: "partner",
  },
  {
    tenantId: 1902,
    displayName: "Anthesis Group",
    id: "anthesis",
    type: "employer",
  },
  {
    tenantId: 1901,
    displayName: "The EVERY Company",
    id: "every",
    type: "employer",
  },
  {
    tenantId: -1,
    id: "demo",
    displayName: "[Your company name]",
    type: "employer",
  },
  {
    tenantId: 2001, // add for employer dashboard custom url page
    displayName: "California Pan-Ethnic Health Network",
    id: "cpehn",
    type: "employer",
  },
  // FOR testing purpose
  {
    tenantId: -1,
    id: "maplan",
    displayName: "M&A Company",
    type: "employer",
  },
  {
    tenantId: -1,
    id: "planchange",
    displayName: "Plan Change Company",
    type: "employer",
  },
  {
    tenantId: -1,
    id: "cctestemployer",
    displayName: "CC Employer Company",
    type: "employer",
  },
  {
    tenantId: 2051,
    id: "aim",
    displayName: "American Iron & Metal U.S.A. Inc",
    type: "employer",
  },
  {
    tenantId: 2051,
    id: "ers",
    displayName: "American Iron & Metal U.S.A. Inc",
    type: "employer",
  },
  {
    tenantId: 2101,
    id: "stand",
    displayName: "Stand.earth",
    type: "employer",
  },
  {
    tenantId: 3001,
    id: "cac",
    displayName: "Climate Action Campaign",
    type: "employer",
  },
  {
    tenantId: 3002,
    id: "ild",
    displayName: "Immigrant Legal Defense",
    type: "employer",
  },
  {
    tenantId: 3003,
    id: "projectdrawdown",
    displayName: "Project Drawdown",
    type: "employer",
  },
  {
    tenantId: 2151,
    id: "aigen",
    displayName: "Aigen",
    type: "employer",
  },
  {
    tenantId: 3004,
    id: "synergillc",
    displayName: "Synergi LLC",
    type: "employer",
  },
] as const;

export type SlugValidation = {
  adminStatus: "INR" | "RCM" | null;
  companyName: string;
  companyType: "EMP" | "PTR";
  launchDate: string;
  presignedLogoUrl: string;
};

export type VendorConfigIds = typeof vendorConfigs[any]["id"];

export const getVendor = (vendor: VendorConfigIds) => {
  return vendorConfigs.find((item) => item.id === vendor);
};

export const getVendorIds = () => {
  return vendorConfigs.map((item) => item.id).sort();
};

export const getVendorByTenantId = (tenantId: number) => {
  return vendorConfigs.find((item) => item.tenantId === tenantId);
};

export const getVendorByTenantIdMulti = (tenantId: number) => {
  return vendorConfigs.filter((item) => item.tenantId === tenantId);
};
